import { render } from "./DeductionsModal.vue?vue&type=template&id=7c93c3ac&scoped=true"
import script from "./DeductionsModal.vue?vue&type=script&lang=js"
export * from "./DeductionsModal.vue?vue&type=script&lang=js"

import "./DeductionsModal.vue?vue&type=style&index=0&id=7c93c3ac&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c93c3ac"]])

export default __exports__